import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThumbsUp,
  faHeart,
  faLaugh,
  faSurprise,
  faSadCry,
  faAngry,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

const styles = {
  actionButton: {
    fontSize: "18px",
    color: "#E75B82",
    cursor: "pointer",
    border: "none",
    background: "none",
    width: "100%",
    height: "100%",
    borderRadius: "4px",
    transition: "background 0.2s",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  iconContainer: {
    position: "absolute",
    // top: "100%",
    // left: "50%",
    width: "240px",
    transform: "translate(-30%, 5px)",
    display: "none",
    backgroundColor: "#fff",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    padding: "5px",
    zIndex: 1,
  },
  visible: {
    display: "block",
  },
  icon: {
    marginRight: "15px",
    fontSize: "24px",
  },
  reactionStatsContainer: {
    display: "flex",
    alignItems: "center",
    marginRight:"10px",
    fontSize: "18px",
    color: "#E75B82",
    // marginBottom:"10px"
  },
  reactionStats: {
    display: "flex",
    alignItems: "center",
  },
  reactionStat: {
    display: "flex",
    alignItems: "center",
    marginRight: "5px",
  },
};

const reactionsIcons = {
  like: faThumbsUp,
  love: faHeart,
  haha: faLaugh,
  wow: faSurprise,
  sad: faSadCry,
  angry: faAngry,
};

const LikeCommentModal = ({ commentKey, totalReactions, setShowLoginModal }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reactionsCount, setReactionsCount] = useState(totalReactions);

  const reactionButtonRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        reactionButtonRef.current &&
        !reactionButtonRef.current.contains(e.target)
      ) {
        setIsClicked(false);
      }
    };

    document.body.addEventListener("click", handleOutsideClick);
    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleClick = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setShowLoginModal(true);
      return;
    }
    setIsClicked(!isClicked);
  };

  const handleIconClick = async (icon) => {
    const token = localStorage.getItem("token");
    if (!token) {
      setShowLoginModal(true);
      return;
    }
    setSelectedIcon(icon.emoji);
    setIsClicked(false);

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/community-reactions`,
        { reactable_key: commentKey, reactable_type: "comment" , type: icon.reactionType },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === 200) {
        setReactionsCount(reactionsCount + 1);
        setSelectedIcon(icon.emoji);
      } else if (response.data.status === 202) {
        setReactionsCount(reactionsCount - 1);
      } else if (response.data.status !== 201) {
        NotificationManager.error(
          "Failed to react post! Please try again!",
          "Error"
        );
      }
    } catch (error) {
      NotificationManager.error(
        "Error reacting to post! Please try again!",
        "Error"
      );
    }
    setLoading(false);
  };

  return (
    <>
        <div style={styles.reactionStatsContainer} ref={reactionButtonRef} onClick={handleClick}>
          {/* <div style={styles.reactionStat}> */}
            <FontAwesomeIcon icon={faThumbsUp} />
          <span style={{marginLeft:'5px'}}>{reactionsCount}</span>
          {/* </div> */}
        </div>
        <div
          style={{ ...styles.iconContainer, ...(isClicked && styles.visible) }}
        >
          <FontAwesomeIcon
            icon={faThumbsUp}
            style={{ marginRight: "15px", fontSize: "24px", color: "#2472F1" }}
            onClick={() =>
              handleIconClick({ emoji: faThumbsUp, reactionType: "like" })
            }
          />
          <FontAwesomeIcon
            icon={faHeart}
            style={{ marginRight: "15px", fontSize: "24px", color: "#FA1502" }}
            onClick={() =>
              handleIconClick({ emoji: faHeart, reactionType: "love" })
            }
          />
          <FontAwesomeIcon
            icon={faLaugh}
            style={{ marginRight: "15px", fontSize: "24px", color: "#ffd700" }}
            onClick={() =>
              handleIconClick({ emoji: faLaugh, reactionType: "haha" })
            }
          />
          <FontAwesomeIcon
            icon={faSurprise}
            style={{ marginRight: "15px", fontSize: "24px", color: "#ffd700" }}
            onClick={() =>
              handleIconClick({ emoji: faSurprise, reactionType: "wow" })
            }
          />
          <FontAwesomeIcon
            icon={faSadCry}
            style={{ marginRight: "15px", fontSize: "24px", color: "#ffd700" }}
            onClick={() =>
              handleIconClick({ emoji: faSadCry, reactionType: "sad" })
            }
          />
          <FontAwesomeIcon
            icon={faAngry}
            style={{ marginRight: "15px", fontSize: "24px", color: "#FA291B" }}
            onClick={() =>
              handleIconClick({ emoji: faAngry, reactionType: "angry" })
            }
          />
        </div>
        <NotificationContainer />
    </>
  );
};

export default LikeCommentModal;
